import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, PageHeader, Field, Input, Button } from "@/components/ui-kit";
import { TrendingUp, Truck, User } from "lucide-react";
import { formatNumber, todayISO } from "@/lib/format";
import { DatePicker } from "@/components/DatePicker";

const firstOfMonth = () => {
  const d = new Date(); d.setDate(1); return d.toISOString().slice(0, 10);
};

export default function BatchingRekap() {
  const [from, setFrom] = useState(firstOfMonth());
  const [to, setTo] = useState(todayISO());
  const [data, setData] = useState({ by_sopir: [], total_trips: 0, total_volume_m3: 0, unique_trucks_count: 0, sjs: [] });
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get("/batching/rekap-readymix", { params: { date_from: from, date_to: to } });
      setData(r.data || {});
    } catch (e) { setData({ by_sopir: [], total_trips: 0, total_volume_m3: 0, unique_trucks_count: 0, sjs: [] }); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-6">
      <PageHeader overline="Batching Plant" title="Rekap Readymix Keluar" description="Agregasi pengiriman readymix concrete per sopir + total mobil/kubikasi bulanan." icon={TrendingUp} />
      <Card className="p-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-2 items-end">
          <Field label="Dari Tanggal"><DatePicker value={from} onChange={(e) => setFrom(e.target.value)} data-testid="batching-rekap-from" /></Field>
          <Field label="Sampai Tanggal"><DatePicker value={to} onChange={(e) => setTo(e.target.value)} data-testid="batching-rekap-to" /></Field>
          <Button onClick={load} disabled={loading} data-testid="batching-rekap-apply">{loading ? "Memuat..." : "Terapkan Filter"}</Button>
        </div>
      </Card>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card className="p-5"><div className="flex items-center gap-3"><Truck className="h-7 w-7 text-terra-600" /><div><div className="text-[10px] uppercase tracking-widest text-stone-500">Total Mobil Keluar</div><div className="text-2xl font-bold text-stone-900 font-mono" data-testid="batching-rekap-total-trips">{formatNumber(data.total_trips || 0)}</div></div></div></Card>
        <Card className="p-5"><div className="flex items-center gap-3"><TrendingUp className="h-7 w-7 text-emerald-600" /><div><div className="text-[10px] uppercase tracking-widest text-stone-500">Total Readymix Terkirim</div><div className="text-2xl font-bold text-stone-900 font-mono" data-testid="batching-rekap-total-volume">{formatNumber(data.total_volume_m3 || 0, 2)} m³</div></div></div></Card>
        <Card className="p-5"><div className="flex items-center gap-3"><User className="h-7 w-7 text-stone-600" /><div><div className="text-[10px] uppercase tracking-widest text-stone-500">Truk Berbeda Dipakai</div><div className="text-2xl font-bold text-stone-900 font-mono">{formatNumber(data.unique_trucks_count || 0)}</div></div></div></Card>
      </div>

      <Card>
        <div className="px-4 py-3 border-b border-stone-200 font-semibold text-sm">Rekap per Sopir</div>
        <table className="w-full text-sm">
          <thead className="bg-stone-50 text-[10px] uppercase tracking-wider text-stone-600">
            <tr><th className="text-left py-2 px-3">Sopir</th><th className="text-right py-2 px-3">Jumlah Mobil (Trip)</th><th className="text-right py-2 px-3">Total Kubikasi (m³)</th><th className="text-left py-2 px-3">Truk Dipakai</th></tr>
          </thead>
          <tbody>
            {(data.by_sopir || []).length === 0 && <tr><td colSpan={4} className="text-center text-stone-400 py-8 text-xs">Tidak ada SJ pada rentang ini.</td></tr>}
            {(data.by_sopir || []).map((s) => (
              <tr key={s.sopir} className="border-b border-stone-100" data-testid={`batching-rekap-sopir-${s.sopir}`}>
                <td className="py-2 px-3 font-semibold">{s.sopir}</td>
                <td className="py-2 px-3 text-right font-mono">{formatNumber(s.trips)}</td>
                <td className="py-2 px-3 text-right font-mono font-bold">{formatNumber(s.volume_m3, 2)}</td>
                <td className="py-2 px-3 text-stone-600 text-xs">{(s.trucks || []).join(", ") || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
